<template>
  <div>
    <div v-if="loadingShow">
      <div class="gcloading">
        <img src="https://static.mingchu.co/webapp/images/components/animation_load.gif">
      </div>
    </div>
    <div class="scrollBox">
      <!-- 页面内容 -->
      <div class="g_1">
        <div class="img_box"><img :src="userInfo.usr_pic" alt=""></div>
        <div class="user_name">{{ userInfo.nick_name }}</div>
      </div>
      <div class="g_2" />
      <div class="ipt_tbox">
        <input id="telphone" v-model="mobile" type="text" class="ipt_tel" placeholder="输入手机号">
        <div class="i_box clearfix">
          <input v-model="mobileCode" type="text" class="ipt_nums" placeholder="输入验证码">
          <a v-if="countTime==60" id="send_code" href="javascript:;" class="btn_nums" @click="sendCode">发送验证码</a>
          <a v-else id="send_code" href="javascript:;" class="btn_nums checked_btn" @click="sendCode">{{ countTime }}s后重新获取</a>
        </div>

      </div>
      <div class="btn_pull">
        <a id="draw" href="javascript:;" class="btn_lq" @click="submitFn">立即领取</a>
      </div>
      <div class="cond_g">
        <div class="t" />
        <div class="cont tc pt70">
          <div class="top">好厨师 在这里</div>
          <div class="tit_1"><span class="t1"><span class="t1_1">一个属于厨师的圈子</span></span></div>
          <p class="txt1">全球顶尖的烹饪艺术大师、极具创造力的新锐厨师、因热情而踏上烹饪之旅的餐饮新星</p>
          <p class="txt_str">与他们，零距离</p>
          <div class="tit_1"><span class="t1"><span class="t1_1">一个专业美食交流平台</span></span></div>
          <p class="txt2">拿起手机，对准美食，轻轻上传，与专业的食物艺术家进行交流、切磋。了解美食背后的真相，掌握老饕的味蕾变幻。自此，踏上专业的美食爱好者之旅。</p>
          <img src="https://static.mingchu.co/invite/images/g/p1.jpg" alt="" class="p1">
          <div class="tit_1"><span class="t1"><span class="t1_1">与大师互动获取灵感</span></span></div>
          <p class="txt2">限制你发挥的一切均可向大师请教，一句提点即有拨云见日的效果。没有不劳而获的灵感，无论是大师还是餐饮新星，对于你提出的任何问题均会予以解答。灵光乍现，在大师互动中绽放。</p>
          <img src="https://static.mingchu.co/invite/images/g/p2.jpg" alt="" class="p2">
          <div class="tit_1"><span class="t1"><span class="t1_1">厨师品牌</span></span></div>
          <p class="txt2">美食如同作品，厨师如同艺术家。任何人都不应该只品尝美食，而忽略了创造美食的艺术家。在这里，让专业的厨师，用厨师的专业，征服食客，折服同行。你的名字，就是你的品牌。</p>
          <img src="https://static.mingchu.co/invite/images/g/p3.jpg" alt="" class="p3">

        </div>
        <div class="b" />
      </div>

      <div class="foot" />
    </div>

    <div v-show="giftBag" class="mask">
      <div id="div_gift_bag" class="alt a1">
        <div class="tp" />
        <div class="name" />
        <div class="txt">新人大礼包已放入您的名厨账户，请
          下载名厨APP并使用该手机号注册
          登录，查看礼包</div>
        <a id="bag_go_app" href="javascript:;" class="btn go_app" @click="goApp">前往名厨APP查看</a>
        <a href="javascript:;" class="close" @click="giftBag = false" />
      </div>
    </div>
    <div v-show="oldUser" class="mask">
      <div id="div_old_user" class="alt a2">
        <div class="oldf" />
        <div class="txt">您可邀请好友加入名厨<br>
          每邀请成功一位，可得<span>200积分</span></div>
        <a id="old_go_app" href="javascript:;" class="btn go_app" @click="goApp">前往名厨APP邀请</a>
        <a href="javascript:;" class="close" @click="oldUser = false" />
      </div>
    </div>
    <div v-show="haveDraw" class="mask">
      <div id="div_have_draw" class="alt a3">
        <div class="name1" />
        <div class="txt">新人大礼包已放入您的名厨账户，请
          下载名厨APP并使用该手机号注册登
          录，查看礼包！</div>
        <a id="draw_go_app" href="javascript:;" class="btn go_app" @click="goApp">前往名厨APP邀请</a>
        <a href="javascript:;" class="close" @click="haveDraw = false" />
      </div>
    </div>

    <input id="uid" type="hidden" :value="userInfo.uid">
    <input id="shareTitle" type="hidden" :value="shareInfo.shareTitle">
    <input id="shareDesc" type="hidden" :value="shareInfo.shareDesc">
    <input id="shareImg" type="hidden" :value="shareInfo.shareImg">
    <input id="shareLink" type="hidden" :value="shareInfo.shareLink">
  </div>
</template>

<script>
// import { Navbar, TabItem, Indicator, InfiniteScroll, Toast } from 'mint-ui'
import { articles, ajaxHttp } from '@/api/api'
// import utils from '@/utils/utils'
import config from '@/config/config'
import wx from 'weixin-js-sdk'
// import '../../style/styles.css'
import { Toast } from 'vant'
export default {
  data() {
    return {
      loadingShow: true,
      giftBag: false,
      oldUser: false,
      haveDraw: false,
      isGteatChefbrowser: false,
      mobile: '',
      mobileCode: '',
      countTime: 60,
      countDownFn: null,
      userInfo: {},
      shareInfo: {
        shareTitle: '送你一份名厨新手礼包，快来开启你的名厨之路吧！',
        shareDesc: '可用于兑换商品、申请产品试用等。上名厨，与烹饪艺术大师零距离！',
        shareImg: 'https://static.mingchu.co/m/images/weblogo.png',
        shareLink: `${config.webapplink}/htmlPage/inviteRegister`
      },
      pathInfo: {}
    }
  },
  created() {
    const self = this
    /* eslint-disable */
    const dsType = dsBridge.call('openBackButton', 'test')
    const { query } = self.$route
    if (dsType == 1) { // app内
      self.isGteatChefbrowser = true
    }
    self.pathInfo = query
    this.getData(query.id)
  },
  mounted() {
    const self = this
    this.$nextTick(() => {
      self.share(self.shareInfo)
    })
  },
  methods: {
    getData($id) {
      const self = this
      ajaxHttp.$get('/invite/register', { id: $id }).then(res => {
        if (res.code == 1) {
          this.userInfo = res.data
          this.shareInfo.shareLink = `${self.shareInfo.shareLink}?id=${res.data.uid}`
        } else {}
        self.$nextTick(() => {
          self.loadingShow = false
        })
      }).catch(err => {
        console.log(err)
      })
    },
    goApp() {
      location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.com.greatchef'
    },
    getDataPromiss($url, $data, $type) {
      return new Promise((resolve, reject) => {
        ajaxHttp.$get($url, $data).then(res => {
          if (res.code == 1) {
            this[$type] = res.data
            resolve(res.data)
          } else {}
        }).catch(err => {
          console.log(err)
        })
      })
    },
    sendCode() {
      const self = this
      const reg = /^[1][2-8]\d{9}$/
      if (!reg.test(self.mobile)) {
        Toast('请输入正确的手机号')
        return false
      }
      const data = {
        telphone: this.mobile,
        plant: 4
      }
      clearInterval(self.countDownFn)
      self.countDownFn = setInterval(() => {
        self.countTime--
        if (self.countTime <= 0) {
          clearInterval(self.countDownFn)
          self.countTime = 60
        }
      }, 1000)

      ajaxHttp.$post('/invite/send_code', data).then(res => {
        switch (res.code) {
          case 27:
            this.oldUser = true
            break
          case 90:
            this.haveDraw = true
            break
          case 1:
            // countDown()
            Toast('发送成功')
            break
          default:
            // countDown()
            Toast(res.message)
            break
        }
      }).catch(err => {
        console.log(err)
      })
    },
    submitFn() {
      const self = this
      const data = {
        telphone: this.mobile,
        code: this.mobileCode,
        uid: this.userInfo.uid
      }
      const reg = /^[1][2-8]\d{9}$/
      if (!reg.test(self.mobile)) {
        Toast('请输入正确的手机号')
        return false
      }
      if (this.mobileCode == '') {
        Toast('请输入验证码')
        return false
      }
      ajaxHttp.$post('/invite/draw', data).then(res => {
        switch (res.code) {
          case 1:
            this.giftBag = true
            this.mobile = ''
            this.mobileCode = ''
            break
          default:
            Toast(res.message)
            break
        }
      }).catch(err => {
        console.log(err)
        Toast('网络异常，稍后再试试')
      })
    },
    share($shareInfo) {
      // const self = this
      const share_url = escape(window.location.href)
      articles.share(share_url).then(res => {
        wx.config({
          debug: false,
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名，见附录1
          jsApiList: res.jsApiList
        })
        wx.ready(() => {
          const share_title = $shareInfo.shareTitle
          const share_desc = $shareInfo.shareDesc
          const share_link = $shareInfo.shareLink
          const share_img = $shareInfo.shareImg
          console.log('分享测试', share_title, share_desc)

          wx.updateAppMessageShareData({
            title: share_title, // 分享标题
            desc: share_desc, // 分享描述
            link: share_link + '?referrer=share_wx', // 分享链接
            imgUrl: share_img, // 分享图标
            success: function() {
						  // 设置成功
				    }
          })
          wx.updateTimelineShareData({ // 分享给朋友
            title: share_title, // 分享标题
            desc: share_desc, // 分享描述
            link: share_link + '?referrer=share_wx_circle', // 分享链接
            imgUrl: share_img, // 分享图标
            success: function() {
              // 设置成功
					  }
          })
        })
      })
    }

  }
}
</script>
<style lang="scss" scoped>
  @import url('https://static.mingchu.co/invite/styles/styles.css');
  @function rem($px){
    @return ($px/3)*1rem;
  }
  .constent{ overflow:hidden;}
  .scrollBox{position: static;}
  .cond_g{position: static; overflow: overlay;}
  .mask{ opacity: 1 !important; background: rgba(0,0,0,0.7) !important; }
  .checked_btn{background-color: rgb(189, 189, 189); color: #fff;}
  .tabBox .bd .list_bang .fl_m{padding-top: 1.3rem;}
  .tabBox .bd .list_bang .img_box{margin-top: 0;}
  .tabBox .bd .list_bang .bang{margin-top: 0;}
  .tabBox .bd .list_bang .fl_m{padding-top: 0;}
  .img_box{display: flex; align-items: center;}
  .ipt_nums{font-size: 45px !important}
  .dis_flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .gcloading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 999;
	img{
		width: 125px;
		position: absolute;
		top: 30vh;
		left: 50%;
    transform: translateX(-50%);
	}
}
.g_1 {
    width: 100%;
    height: rem(14.4);
    background-size: rem(30) rem(17.2);
    padding-top: rem(2.8);
}
.g_1 .img_box {
    width: rem(4.72);
    height: rem(4.72);
    border: 1px solid #fff;
    padding: rem(0.24);
    margin: 0 auto;
    border-radius: rem(2.8);
}
.g_1 img {
    width: rem(4.4);
    height: rem(4.4);
    border: 2px solid #fff;
    vertical-align: top;
    border-radius: rem(2.4);
}
.g_1 .user_name {
    padding-top: rem(0.4);
    font-size: rem(1.6);
    height: rem(2.4);
}
.g_2{height:rem(12.32);background-size: rem(30) rem(12.32);}
.ipt_tbox .ipt_tel{width:rem(26.96);height: rem(3.6);border-radius: rem(.4);font-size: rem(1.2);text-indent: rem(1.6);}
.ipt_tbox .i_box{width: rem(26.96);padding:rem(.72) 0;}
.ipt_nums{font-size: rem(1.2) !important;}
.ipt_tbox .ipt_nums{float: left;
  width: rem(17.6);
  height: rem(3.6);
  border-radius: rem(0.4);
  text-indent: rem(1.6);
} 
.ipt_tbox .btn_nums{
    width: rem(8.88);
    height: rem(3.6);
    border-radius: rem(0.4);
    font-size: rem(1.2);
    line-height: rem(3.6);
}
.btn_pull{
  padding: 0 0 rem(0.9);
}
.btn_pull .btn_lq{
  width: rem(30);
  height: rem(4.96);
  background-size: rem(30) rem(4.96);
  line-height: rem(4.96);
  font-size: rem(1.44);
}
.cond_g{
    width: rem(27.68);
    margin: 0 auto rem(0.4);
    background-size: rem(27.68) rem(0.4);
}
.cond_g .t{
  width: rem(27.68);
  height: rem(1.2);
  vertical-align: top;
  background-size: rem(27.68) rem(1.2);
}
.pt70{
  padding-top: rem(2.4);
}
.cond_g .b{
  width: rem(27.68);
  height: rem(1.12);
  background-size: rem(27.68) rem(1.12);
}
.cont .top{
  left: rem(8.84);
  top: rem(-1.2);
  width: rem(10);
  height: rem(2.16);
  background-size: rem(10) rem(2.16);
  line-height: rem(2.16);
  font-size: rem(1.2);
}
.tit_1{ padding-bottom: rem(0.8);}
.tit_1 .t1{padding-bottom: rem(0.32);}
.tit_1 .t1_1{font-size: rem(1.44);}
.txt1{font-size: rem(1.04);
    padding: 0 rem(1.6) rem(1.12);
    text-align: center;
    line-height: rem(1.84);}
.txt_str{
  font-size: rem(1.28);
  padding-bottom: rem(1.84);
}
.txt2{font-size: rem(1.04);
    padding: 0 rem(1.6) rem(1.12);
    text-align: center;
    line-height: rem(1.84);}
    .p1 {
    width: rem(22.88);
    height: rem(17.2);
    margin-bottom: rem(1.6);
}
.p2 {
    width: rem(11.76);
    height: rem(15.04);
    margin-bottom: rem(1.6);
}
.p3 {
    width: rem(11.76);
    height: rem(16);
    margin-bottom: rem(1.6);
}
.foot {
    width: 100%;
    height: rem(9.6);
    margin-top: rem(-4);
    background-size: rem(30) rem(9.6);
}
.alt {
    width: rem(19.92);
}
.alt .tp {
    left: rem(1.72);
    top: rem(-3.48);
    width: rem(15.36);
    height: rem(6.24);
    background-size: rem(15.36) rem(6.24);
}
.alt .name {
    width: rem(9.12);
    height: rem(3.2);
    margin: rem(3.76) auto 0;
    background-size: rem(9.12) rem(3.2);
}
.alt .txt {
    margin-top: rem(2.4);
    font-size: rem(1.04);
    line-height: rem(1.48);
    padding: 0 rem(1.6);
}
.alt .btn {
    display: block;
    margin: 0 auto 1px;
    width: rem(19.2);
    height: rem(4.64);
    padding-top: rem(0.8);
    line-height: rem(3.52);
    background-size: rem(19.2) rem(5.44);
    font-size: rem(1.44);
}
.alt .close {
    left: rem(8.64);
    bottom: rem(-4.8);
    width: rem(2.64);
    height: rem(2.64);
    background-size: rem(2.64) rem(2.64);
}
.alt .oldf {
    width: rem(19.92);
    height: rem(3.92);
    margin: rem(2) 0 rem(-0.24);
    background-size: rem(19.92) rem(3.92);
}
.alt .name1 {
    width: rem(19.92);
    height: rem(1.6);
    margin: rem(2) auto 0;
    background-size: rem(19.92) rem(1.6);
}
</style>
